module.exports = __webpack_public_path__ + "img/20.d32a8e52.jpg";